
import { Vue, Component, Prop } from "vue-property-decorator";

import InformationWrapper from "@/components/inforationCards/InformationWrapperNew.vue";
import InformationCard from "@/components/inforationCards/InformationCardNew.vue";
import MailTo from "@/components/common/MailTo.vue";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMoreNew.vue";
import PageHeadIcon from "@/components/page/PageHeadIcon.vue";
import FormattedDescription from "@/components/common/FormattedDescription.vue";

import { User_Skill } from "@/generated/graphql";
import ItemChipsData from "@/entities/ItemChipsData";

import { getSkillsForChips } from "@/helpers/cardInfoHelperFunctions/chipDataHelpers";
import TabsWithRoutes from "@/components/common/TabsWithRoutesNew.vue";
import CardPagination from "@/components/card/CardPagination.vue";

import LIST_PROJECTS from "@/apollo/projects/ListProjects.gql";

import { Project, User } from "@/generated/graphql";
import PaginationConfig from "@/entities/PaginationConfig";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholderNew.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import ContractorChips from "@/components/companyProjects/ContractorChips.vue";
import RouteNames from "@/entities/RouteNames";
import ProjectContractorsCardItem from "@/components/projects/ProjectContractorsCardItem.vue";
import paginationConfig from "@/data/paginationConfig";
import EmptyListImageProjects from "@/components/icons/emptyListImages/EmptyListImageProjects.vue";
import ProjectCollection from "@/components/projects/ProjectCollectionNew.vue";
import DocumentsSidebar from "../../../components/managers/DocumentsSidebar.vue";

interface Conditions {
  offset: number;
  // limit: number;
  where: {
    manager: {
      user: {
        id: {
          _eq: string;
        };
      };
    };
  };
}

@Component({
  components: {
    InformationCard,
    InformationWrapper,
    PageHeadIcon,
    FormattedDescription,
    ItemChipsWithMore,
    MailTo,
    CardBodyItem,
    ProjectCollection,
    EmptyListImageProjects,
    CardPagination,
    EmptyListPlaceholder,
    LoadingOverlay,
    ContractorChips,
    DocumentsSidebar,
    TabsWithRoutes,
    ProjectContractorsCardItem,
  },
  apollo: {
    projects: {
      query: LIST_PROJECTS,
      variables() {
        return this.conditions;
      },
      update(data) {
        this.paginationConfig.total = data.total.aggregate.count;
        this.paginationConfig.loadedCount = data.project.length;
        return data.project;
      },
    },
  },
  
})
export default class About extends Vue {
  @Prop({ type: String, required: true }) readonly email!: string;
  @Prop({ type: String, default: undefined }) readonly phone?: string;
  @Prop({ type: String, default: undefined }) readonly about?: string;
  @Prop({ type: String, default: undefined }) readonly jobTitle?: string;
  @Prop({ type: Array, default: () => [] }) readonly skills!: User_Skill[];
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: String, required: true }) readonly managerFullName!: string;
  @Prop({ type: String, required: true }) readonly managerUserId!: string;
  @Prop({ type: String, required: true }) readonly companyId!: string;

  projects?: Project[] = undefined;

  routeNames = RouteNames;

  paginationConfig: PaginationConfig = { ...paginationConfig };

  get offset(): number {
    const { page, limit } = this.paginationConfig;
    return (page - 1) * limit;
  }

  get empty(): boolean {
    if (this.completedProjects === undefined || !this.completedProjects || this.completedProjects.length === 0) {
      return true;
    }

    return false;
  }

  get conditions(): Conditions {
    return {
      offset: this.offset,
      where: {
        manager: {
          user: {
            id: {
              _eq: this.managerUserId,
            },
          },
        },
      },
    };
  }

  get completedProjects(): Project[] {
    if (this.projects) {
      const filterCompletedProjects = this.projects.filter(
        (project) => project.completed
      );
      return filterCompletedProjects;
    }
  }

  get emptyListTitle(): string {
    return ``;
  }

  get emptyListSubtitle(): string {
    return `n/a`;
  }

  async handleRefetch(): Promise<void> {
    await this.$apollo.queries.projects.refetch();
    this.$emit("projectNumberChanged", this.paginationConfig.total);
  }

  get phoneHref(): string | undefined {
    if (!this.phone) {
      return undefined;
    }
    return `tel:+${this.phone}`;
  }

  get managerSkills(): ItemChipsData[] {
    const skills = this.skills.map((userSkill) => userSkill.skill);
    return getSkillsForChips(skills);
  }
}
